// src/components/Store/ProductFilter.jsx
// Barra lateral de filtros estilo marketplace: departamento y rango de precio.
// Controlada por StorePage.
import React from 'react';
import { useTranslation } from 'react-i18next';

export const SORT_OPTIONS = ['featured', 'priceAsc', 'priceDesc', 'name'];

// [min, max) en MXN; null = sin límite
export const PRICE_RANGES = {
  under100: [null, 100],
  from100to250: [100, 250],
  from250to500: [250, 500],
  over500: [500, null],
};

export const inPriceRange = (price, rangeKey) => {
  const range = PRICE_RANGES[rangeKey];
  if (!range) return true;
  const [min, max] = range;
  return (min === null || price >= min) && (max === null || price < max);
};

const FilterLink = ({ active, onClick, children }) => (
  <li>
    <button
      type="button"
      onClick={onClick}
      className={`text-left text-sm leading-6 transition hover:text-[#9A0002] ${
        active ? 'font-bold text-[#3A2A20]' : 'text-[#3A2A20]/80'
      }`}
    >
      {children}
    </button>
  </li>
);

const ProductFilter = ({ filters, onChange, categories, counts }) => {
  const { t } = useTranslation('common');
  const set = (patch) => onChange({ ...filters, ...patch });
  const hasFilters = filters.category || filters.price || filters.search;

  return (
    <div className="space-y-6">
      <section>
        <h2 className="mb-1.5 text-sm font-bold text-[#3A2A20]">{t('store.department')}</h2>
        <ul>
          <FilterLink active={!filters.category} onClick={() => set({ category: '' })}>
            {t('store.categories.all')}
          </FilterLink>
          {categories.map((c) => (
            <FilterLink key={c} active={filters.category === c} onClick={() => set({ category: c })}>
              {t(`store.categories.${c}`)}
              <span className="ml-1 text-xs text-[#3A2A20]/40">({counts[c] || 0})</span>
            </FilterLink>
          ))}
        </ul>
      </section>

      <section>
        <h2 className="mb-1.5 text-sm font-bold text-[#3A2A20]">{t('store.price')}</h2>
        <ul>
          <FilterLink active={!filters.price} onClick={() => set({ price: '' })}>
            {t('store.priceRanges.any')}
          </FilterLink>
          {Object.keys(PRICE_RANGES).map((key) => (
            <FilterLink key={key} active={filters.price === key} onClick={() => set({ price: key })}>
              {t(`store.priceRanges.${key}`)}
            </FilterLink>
          ))}
        </ul>
      </section>

      {hasFilters && (
        <button
          type="button"
          onClick={() => onChange({ ...filters, category: '', price: '', search: '' })}
          className="text-sm font-medium text-[#9A0002] hover:underline"
        >
          {t('store.clearFilters')}
        </button>
      )}
    </div>
  );
};

export default ProductFilter;
